import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const cmgEntityNameColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'linkedCmgEntityName',
  headerName: 'Linked CMG Entity Name',
  initialHide: true,
};
